/**
 * Distance formatting for display (miles vs kilometers).
 * API and storage remain in miles; conversion is display-only.
 */

const MILES_TO_KM = 1.60934;

/**
 * Format distance-from-user (in miles) for display
 * @param {number} miles - Distance in miles
 * @param {string} displayUnit - "miles" or "kilometers"
 * @returns {string} e.g. "2.5 miles away" or "4.0 km away"
 */
export function formatDistanceFromUser(miles, displayUnit = 'miles') {
  if (miles == null || typeof miles !== 'number' || miles < 0) return '';
  if (displayUnit === 'kilometers') {
    const km = miles * MILES_TO_KM;
    return `${km < 1 ? km.toFixed(2) : km.toFixed(1)} km`;
  }
  return `${miles < 1 ? miles.toFixed(2) : miles.toFixed(1)} miles`;
}

/**
 * Format distance in meters for display (e.g. Strava stats)
 * @param {number} meters - Distance in meters
 * @param {string} displayUnit - "miles" or "kilometers"
 * @returns {string} e.g. "3.2 mi" or "5.1 km"
 */
export function formatDistanceMeters(meters, displayUnit = 'miles') {
  if (meters == null || typeof meters !== 'number' || meters < 0) return '0';
  if (displayUnit === 'kilometers') {
    const km = meters / 1000;
    return `${km.toFixed(2)} km`;
  }
  const miles = meters * 0.000621371;
  return `${miles.toFixed(2)} mi`;
}
